import PropTypes from 'prop-types';
import {pathResolver} from '../../utils/basePathHelper';

function UserRegistrationDecoration(props) {
  const youtubeOptions = '?modestbranding=1&color=white';
  const youtubeId = 'O0EozxzhiX8';
  const width = '666';
  const height = '375';

  return (
    <div
      className="pl-5 d-flex justify-content-center align-items-center"
      style={{height: '100%'}}
    >
      {props.language === 'de' ? <img
        alt="user registration"
        style={{width: '100%'}}
        src={pathResolver('resources/svg/user-registration-german.svg')}
      /> :
        <div
          style={{
            backgroundImage: `'url(${pathResolver('resources/svg/user-registration.svg')})'`,
            backgroundPosition: 'center',
            width: '100%',
            height: '100%'
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}${youtubeOptions}`}
            width={width}
            height={height}
            frameBorder="0"
            allowFullScreen
            title="iframe-youtube"
          />
        </div>}
    </div>
  );
}

UserRegistrationDecoration.propTypes = {
  language: PropTypes.string.isRequired
};

export default UserRegistrationDecoration;
